import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { WrapperChatComponent } from './wrapper-chat.component';
import { ChatTabContextService, ChatTabType } from '../../shared-services/chat-tab-context.service';

@Component({
  selector: 'app-chat-tabs',
  standalone: true,
  imports: [CommonModule, WrapperChatComponent],
  templateUrl: './chat-tabs.component.html',
  styleUrls: ['./chat-tabs.component.scss']
})
export class ChatTabsComponent {
  activeTab: ChatTabType = 'help';
  private routeSubscription?: Subscription;

  constructor(
    private route: ActivatedRoute,
    private chatTabContext: ChatTabContextService
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.paramMap.subscribe((params) => {
      const tab = (params.get('tab') || 'sahay').toLowerCase();
      this.activeTab = tab === 'price-action' || tab === 'chat' ? 'chat' : 'help';
      this.chatTabContext.setActiveTab(this.activeTab);
    });
  }

  ngOnDestroy(): void {
    this.routeSubscription?.unsubscribe();
  }
}
